import React from 'react';
import { FormContext } from '../FormContext';
import { InputType } from '../InputType';
import SelectInput from './SelectInput';
import TextInput from './TextInput';
import UneditableInput from './UneditableInput';

export default function InputByType() {
	const formContext = React.useContext(FormContext);
	const {
		rowOptions: { rowTypeData },
	} = formContext;

	switch (rowTypeData.inputType) {
		case InputType.Select:
		case InputType.StatesSelect:
			return <SelectInput />;
		case InputType.TextInput:
			return <TextInput />;
		case InputType.UneditableInput:
			return <UneditableInput />;
		default:
			throw new Error('Invalid input type.');
	}
}
